import React from "react";
import HeroComex from "./HeroComex";
import VideoComex from "./VideoComex";
import BeneficiosComex from "./BeneficiosComex";
import MarcasConfian from "./MarcasConfian";
import TestimoniosComex from "./TestimoniosComex";
import TituloTexto from "./TituloTexto";
import Seo from "./Seo";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function Ejemplo2(props) {
  const {
    hero,
    beneficios,
    clientes,
    video,
    experiencias,
    seo,
    titulo1,
    titulo2,
    titulo_box_1,
    titulo_box_2,
  } = props;

  const breakpoints = {
    0: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
    420: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 1.2, spaceBetween: 30 },
    768: { slidesPerView: 1.5, spaceBetween: 30 },
    1024: { slidesPerView: 2, spaceBetween: 40 },
    1200: { slidesPerView: 3, spaceBetween: 30 },
    1600: { slidesPerView: 4, spaceBetween: 40 },
    2000: { slidesPerView: 4, spaceBetween: 40 },
  };

  const renderTextNode = (node, key) => {
    const { text, bold, italic } = node;

    if (!text) return null;

    let element = <span key={key}>{text}</span>;

    if (bold && italic) {
      element = (
        <strong key={key}>
          <em>{text}</em>
        </strong>
      );
    } else if (bold) {
      element = <strong key={key}>{text}</strong>;
    } else if (italic) {
      element = <em key={key}>{text}</em>;
    }

    return element;
  };

  return (
    <>
      <Seo
        metaTitle={seo[0]?.metatitle}
        metaDescription={seo[0]?.metadescription}
        metaImage={seo[0]?.metaimage?.url}
        metaKeywords={seo[0]?.metakeywords}
        canonicalURL={seo[0]?.canonicalurl}
      />

      <main>
        <section className=" bg-sidom-light dark:bg-sidom-blue  text-center">
          {hero?.length ? (
            hero.map((item, index) => (
              <HeroComex
                key={item.id || index}
                titulo={item.titulo}
                subtitulo={item.text}
                video={item.video?.url}
                imagen={item?.img?.formats?.thumbnail?.url || item.img?.url}
              />
            ))
          ) : (
            <HeroComex titulo="Cargando..." subtitulo="Espere un momento" />
          )}
        </section>
        {/* Texto fondo */}
        {titulo1?.length > 0 ? (
          <section className=" bg-sidom-blue text-center">
            <TituloTexto titulo={titulo1[0]?.titulo} texto={titulo1[0]?.text} />
          </section>
        ) : (
          <TituloTexto titulo="Cargando..." texto="Cargando..." />
        )}

        {/* Video */}
        {video?.length > 0 && (
          <section className="bg-sidom-orange text-center">
            <VideoComex
              key={video[0].id}
              video={video[0].video?.url}
              controls={video[0]?.control}
              autoPlay={video[0]?.autoplay}
              muted={video[0]?.muted}
              loop={video[0]?.loop}
            />
          </section>
        )}

        {/* Clientes */}
        {clientes?.length > 0 && (
          <section className=" bg-sidom-blue text-center">
            <MarcasConfian
              key={clientes.id || clientes[0].index}
              titulo={clientes[0].titulo}
              marcas={clientes[0].img}
            />
          </section>
        )}
        {/* Testimonios */}
        {experiencias?.length > 0 && (
          <section className="">
            <TestimoniosComex
              testimonios={experiencias}
              titulo={titulo_box_2}
            />
          </section>
        )}
        {titulo2[0]?.length > 0 && (
          <section className=" bg-sidom-blue text-center">
            {titulo1 ? (
              <TituloTexto
                titulo={titulo2[0]?.titulo}
                texto={titulo2[0]?.text}
              />
            ) : (
              <TituloTexto titulo="Cargando..." texto="Cargando..." />
            )}
          </section>
        )}
        {/* Beneficios */}

        {beneficios?.length > 0 && (
          <section className=" ">
            <div className="container">
              <h1 className="text-left text-3xl md:text-[40px] lg:text-[45px] leading-tight px-2 md:px-0 lg:px-0 font-extrabold text-sidom-orange mb-8">
                {titulo_box_1?.titulo?.map((child, index) =>
                  renderTextNode(child, index)
                ) || "Título predeterminado"}
              </h1>
            </div>
            <div className="relative container  mb-[70px] md:mb-[100px] lg:mb-[90px]">
              <Swiper
                spaceBetween={30}
                speed={8000}
                autoplay={{
                  delay: 1,
                  disableOnInteraction: false,
                  reverseDirection: true,
                }}
                centeredSlides={true}
                onSwiper={(swiper) => swiper.slideTo(0, 0)}
                modules={[Autoplay, Pagination, Navigation]}
                breakpoints={breakpoints}
                className="mySwiper"
              >
                {beneficios.map((item, index) => (
                  <SwiperSlide key={item.id}>
                    <BeneficiosComex
                      key={item.id || index}
                      icon={
                        item.icon?.formats?.thumbnail?.url || item.icon?.url
                      }
                      titulo={item.titulo}
                      subtitulo={item.subtitulo}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </section>
        )}
      </main>
    </>
  );
}
